import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/index'
import contact from '@/contact'
import blog from '@/blog'
import detail from '@/detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/blog',
      name: 'blog',
      component: blog
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js